import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountManagerLayerApi } from './accountManager.layer.api';
import { IAccountInfo } from './models/account-info';
import { ResponseDataTransfer, TransferDataRequest } from './models/transfer-session-model';

@Injectable({
  providedIn: 'root'
})
export class AccountManagerResourcesService {
  private readonly accountManagerService = inject(AccountManagerLayerApi);

  public transferSessionB2C(request: TransferDataRequest): Observable<ResponseDataTransfer> {
    return this.accountManagerService.transferToB2C(request);
  }

  public createCookie(): Observable<boolean> {
    return this.accountManagerService.createSharedCookie();
  }

  public getAccountInfo(): Observable<IAccountInfo> {
    return this.accountManagerService.accountInfo();
  }
}
